// extracted by mini-css-extract-plugin
module.exports = {"container":"CopyableLink_container__vr3hj","clickableIcon":"CopyableLink_clickableIcon__1bvMw","reverse":"CopyableLink_reverse__1eCbo"};